<template>
  <div>
    <!-- ── Logo centrado arriba, sin hero de fondo ─────────────────────── -->
    <div class="logo-header">
      <img src="@/assets/logo2.png" alt="Logo" class="logo-img" />
    </div>

    <section class="section">
      <div class="container">
        <!-- Pill flotante: nombre de la encuesta en pase 0, sección en los demás -->
        <div class="has-text-centered survey-tag-wrap">
          <p class="survey-tag" v-if="pase === 0">
            Líderes PHD · Personas que hacen la diferencia
          </p>
          <p class="survey-tag" v-if="pase === 1">Datos demográficos</p>
          <p class="survey-tag" v-if="pase === 2">Instrucciones</p>
          <p class="survey-tag" v-if="pase === 3">Preguntas</p>
        </div>

        <div
          class="box survey-box"
          :class="{
            'survey-box--flat': pase === 1 || pase === 2 || pase === 3,
          }"
        >
          <!-- ══════════════════════════════════════════
               PASE 0 — Bienvenida + Consentimiento
          ══════════════════════════════════════════ -->
          <div v-show="pase === 0">
            <h1 class="title survey-title">
              {{ candidate.isBoss ? title.lider : title.colaboradores }}
              <span v-if="candidate.isBoss">{{
                relacion.evaluador.nombre
              }}</span>
            </h1>
            <h2 class="subtitle has-text-centered" v-if="!candidate.isBoss">
              Aquí vas a evaluar a
              <strong>{{ relacion.evaluado.nombre }}</strong>
            </h2>

            <div class="info-block">
              <span style="white-space: pre-line">
                {{
                  candidate.isBoss
                    ? infoForUser.lider.Lider
                    : infoForUser.colaboradores.Colaborador
                }}
              </span>
            </div>

            <p class="help-note has-text-centered">
              *Si tienes dificultades comunícate con
              <span class="help-note__email">elena@sietegho.com</span>
            </p>

            <div class="has-text-centered mt-5">
              <modal-consentimiento
                :show="!responses.agree"
                @aceptConsent="aceptConsent"
                @next="next"
                @endno="endno"
                :isBoss="candidate.isBoss"
              ></modal-consentimiento>

              <b-button
                v-show="responses.agree"
                type="is-dark"
                size="is-medium"
                icon-right="arrow-right"
                :disabled="!responses.agree"
                @click="next()"
              >
                Siguiente
              </b-button>
            </div>
          </div>

          <!-- ══════════════════════════════════════════
               PASE 1 — Datos demográficos
          ══════════════════════════════════════════ -->
          <div v-show="pase === 1">
            <div class="field-block">
              <label class="field-label">Género</label>
              <div class="pill-group">
                <b-radio-button
                  v-model="responses.genre"
                  native-value="Masculino"
                  type="is-dark"
                >
                  Masculino
                </b-radio-button>
                <b-radio-button
                  v-model="responses.genre"
                  native-value="Femenino"
                  type="is-dark"
                >
                  Femenino
                </b-radio-button>
                <b-radio-button
                  v-model="responses.genre"
                  native-value="Otro"
                  type="is-dark"
                >
                  Otro
                </b-radio-button>
              </div>
            </div>

            <b-field label="Edad" class="field-block">
              <b-input
                type="number"
                v-model="responses.age"
                placeholder="Ingrese su edad"
                min="0"
                style="max-width: 200px;"
                @keypress.native="blockNegativeKey"
              ></b-input>
            </b-field>

            <b-field label="Nivel educativo alcanzado" class="field-block">
              <b-select
                v-model="responses.education"
                placeholder="Selecciona tu nivel educativo"
                expanded
              >
                <option value="ninguno">Ninguno</option>
                <option value="primaria-completa">Primaria completa</option>
                <option value="bachillerato-completo"
                  >Bachillerato completo</option
                >
                <option value="Tecnico/tecnologico-completo"
                  >Técnico/tecnológico completo</option
                >
                <option value="profesional-completo"
                  >Profesional completo</option
                >
                <option value="post-grado-completo">Post-grado completo</option>
              </b-select>
            </b-field>

            <div class="field-row">
              <b-field label="País" class="field-block field-block--half">
                <b-select
                  v-model="responses.country"
                  placeholder="Selecciona tu país"
                  expanded
                >
                  <option v-for="(name, index) in countryNames" :key="index">
                    {{ name }}
                  </option>
                </b-select>
              </b-field>

              <b-field label="Ciudad" class="field-block field-block--half">
                <b-select
                  v-model="responses.city"
                  placeholder="Selecciona tu ciudad"
                  expanded
                  @input="showOtherC"
                >
                  <option
                    :key="otherC === '' ? 'Otra...' : otherC.toUpperCase()"
                  >
                    {{ otherC === "" ? "Otra..." : otherC.toUpperCase() }}
                  </option>
                  <option
                    v-for="(name, index) in citysNames[responses.country]"
                    :key="index"
                  >
                    {{ name }}
                  </option>
                </b-select>
              </b-field>
            </div>

            <b-field
              label="Otra ciudad"
              class="field-block"
              v-show="showOtherInput"
            >
              <b-input
                type="text"
                v-model="otherC"
                placeholder="Ingrese su ciudad"
              ></b-input>
            </b-field>

            <div class="has-text-centered mt-5">
              <b-button
                type="is-dark"
                size="is-medium"
                icon-right="arrow-right"
                :disabled="
                  !this.responses.genre ||
                    !this.responses.age ||
                    !this.responses.education ||
                    !this.responses.country ||
                    !(this.responses.city !== 'Otra...' && this.responses.city)
                "
                @click="next()"
              >
                Siguiente
              </b-button>
            </div>
          </div>

          <!-- ══════════════════════════════════════════
               PASE 2 — Instrucciones
          ══════════════════════════════════════════ -->
          <div v-show="pase === 2">
            <div class="content instructions-content">
              <p>
                {{
                  candidate.isBoss
                    ? instruccion.lider.parrafo1
                    : instruccion.colaboradores.parrafo1
                }}
              </p>
              <p>
                {{
                  candidate.isBoss
                    ? instruccion.lider.parrafo2
                    : instruccion.colaboradores.parrafo2
                }}
              </p>
              <p>
                <strong>{{
                  candidate.isBoss
                    ? instruccion.lider.parrafo3
                    : instruccion.colaboradores.parrafo3
                }}</strong>
              </p>

              <div class="scale-example">
                <p class="scale-example__hint">
                  Si estás más o menos en desacuerdo con esta afirmación puedes
                  marcar así:
                </p>
                <div
                  class="scale-grid"
                  :class="{ 'scale-grid--with-nose': !candidate.isBoss }"
                >
                  <div
                    v-if="!candidate.isBoss"
                    class="scale-square scale-square--nose"
                  >
                    No sé
                  </div>
                  <div
                    v-for="n in 10"
                    :key="n"
                    class="scale-square"
                    :class="{ 'is-selected': n === 3 }"
                  >
                    {{ n }}
                  </div>
                </div>
                <div class="scale-endlabels">
                  <span>Totalmente en desacuerdo</span>
                  <span class="has-text-right">Totalmente de acuerdo</span>
                </div>
              </div>

              <div class="scale-example">
                <p class="scale-example__hint">
                  Si estás más o menos de acuerdo con esta afirmación puedes
                  marcar así:
                </p>
                <div
                  class="scale-grid"
                  :class="{ 'scale-grid--with-nose': !candidate.isBoss }"
                >
                  <div
                    v-if="!candidate.isBoss"
                    class="scale-square scale-square--nose"
                  >
                    No sé
                  </div>
                  <div
                    v-for="n in 10"
                    :key="n"
                    class="scale-square"
                    :class="{ 'is-selected': n === 8 }"
                  >
                    {{ n }}
                  </div>
                </div>
                <div class="scale-endlabels">
                  <span>Totalmente en desacuerdo</span>
                  <span class="has-text-right">Totalmente de acuerdo</span>
                </div>
              </div>
            </div>

            <div class="has-text-centered mt-5 button-row">
              <b-button @click="prev()">Anterior</b-button>
              <b-button type="is-dark" icon-right="arrow-right" @click="next()">
                Siguiente
              </b-button>
            </div>
          </div>

          <!-- ══════════════════════════════════════════
               PASE 3 — Preguntas
          ══════════════════════════════════════════ -->
          <div class="has-text-left question" v-show="pase === 3">
            <h2 class="title is-5 survey-title--sm">
              <span v-show="candidate.isBoss">
                Autoevaluación líderes - {{ relacion.evaluado.nombre }}
              </span>
              <span v-show="!candidate.isBoss">
                Estás evaluando a {{ relacion.evaluado.nombre }}
              </span>
            </h2>

            <div
              class="question-row"
              v-for="(question, index) in displayedQuestions"
              :key="index"
            >
              <p class="question-row__text">
                <span class="question-row__num"
                  >{{ question.numeroPregunta }}.</span
                >
                {{ candidate.isBoss ? question.lider : question.colaboradores }}
              </p>

              <div
                class="scale-grid"
                :class="{ 'scale-grid--with-nose': !candidate.isBoss }"
                role="radiogroup"
                :aria-label="
                  candidate.isBoss ? question.lider : question.colaboradores
                "
              >
                <b-radio-button
                  v-if="!candidate.isBoss"
                  v-model="responses[question.codigo]"
                  native-value="0"
                  type="is-dark"
                  class="scale-square-btn scale-square-btn--nose"
                >
                  No sé
                </b-radio-button>

                <b-radio-button
                  v-for="n in 10"
                  :key="n"
                  v-model="responses[question.codigo]"
                  :native-value="String(n)"
                  :name="question.codigo"
                  type="is-dark"
                  class="scale-square-btn"
                >
                  {{ n }}
                </b-radio-button>
              </div>

              <div class="scale-endlabels">
                <span>Totalmente en desacuerdo</span>
                <span class="has-text-right">Totalmente de acuerdo</span>
              </div>
            </div>

            <!-- Espaciador para que la última pregunta no quede tapada por el footer fijo -->
            <div class="footer-spacer"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         Footer fijo: progreso + navegación (solo en pase 3)
    ══════════════════════════════════════════ -->
    <div v-if="pase === 3" class="survey-footer">
      <div class="survey-footer__inner">
        <div class="progress-wrap">
          <div class="progress-info">
            <span>Página {{ page }} de {{ numberOfPages }}</span>
            <span>{{ Math.round((page / numberOfPages) * 100) }}%</span>
          </div>
          <progress
            class="progress is-dark is-small"
            :value="(page / numberOfPages) * 100"
            max="100"
          ></progress>
        </div>

        <div class="footer-nav">
          <b-button
            icon-left="arrow-left"
            class="footer-nav__prev"
            @click="
              backquestion();
              scrollTop();
            "
          >
            Anterior
          </b-button>

          <b-button
            v-if="page !== numberOfPages"
            type="is-dark"
            icon-right="arrow-right"
            class="footer-nav__next"
            :disabled="
              !(
                Object.keys(responses).length - numberOfOthersResponses >
                page * perPage - 1
              )
            "
            @click="nextquestions()"
          >
            Siguiente
          </b-button>
          <b-button
            v-else
            type="is-success"
            icon-right="check"
            class="footer-nav__next"
            :disabled="
              !(
                questions.length ==
                Object.keys(responses).length - numberOfOthersResponses
              )
            "
            @click="end()"
          >
            Finalizar
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import json from "./infoEncuesta.json";
import modalConsentimiento from "../modals/ModalConsentimiento";

export default {
  data() {
    return {
      relacion: {
        evaluado: "",
        evaluador: "",
      },
      pase: 0,
      candidate: {},
      isBoss: null,
      responses: {
        agree: false,
      },
      countryNames: json.countrys,
      citysNames: json.citys,
      otherC: "",
      showOtherInput: false,
      title: json.title,
      consentimiento: json.consentimiento,
      infoForUser: json.welcome,
      instruccion: {
        lider: {
          parrafo1:
            "Vas a encontrarte afirmaciones que describen comportamientos de los líderes. Responde en una escala de 1 a 10 qué tanto consideras que tu actúas de esa manera. Ten en cuenta que el 1 corresponde a “Totalmente en desacuerdo” y el 10 a “Totalmente de acuerdo”, puedes utilizar todos los niveles intermedios para expresar lo que piensas.",
          parrafo2:
            "Recuerda que no hay respuestas buenas o malas. Lo que importa es conocer tu percepción frente a tu comportamiento como líder. Trata de responder rápidamente, no te detengas mucho en cada afirmación.",
          parrafo3: "A continuación te presentamos algunos ejemplos:",
        },
        colaboradores: {
          parrafo1:
            "Vas a encontrarte afirmaciones que describen comportamientos de los líderes. Responde en una escala de 1 a 10 qué tanto consideras que tu líder actúa de esa manera. Ten en cuenta que el 1 corresponde a “Totalmente en desacuerdo” y el 10 a “Totalmente de acuerdo”, puedes utilizar todos los niveles intermedios para expresar lo que piensas. Evita usar la opción “No sé” o utilízala lo menos posible y solo cuando sea estrictamente necesario.",
          parrafo2:
            "Recuerda que no hay respuestas buenas o malas. Lo que importa es conocer tu percepción frente al comportamiento de tu líder. Trata de responder rápidamente, no te detengas mucho en cada afirmación.",
          parrafo3: "A continuación te presentamos algunos ejemplos:",
        },
      },
      tipo: "colaboradores",
      questions: json.questions,
      othersQuestions: [
        "agree",
        "genre",
        "age",
        "education",
        "country",
        "city",
      ],
      numberOfOthersResponses: 6,
      page: 1,
      perPage: 8,
      numberOfPages: 0,
    };
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        behavior: "smooth",
        left: 0,
        top: 200,
      });
    },
    aceptConsent(res) {
      this.responses.agree = res;
    },
    blockNegativeKey(e) {
      if (e.key === "-" || e.key === "+" || e.key === "e") {
        e.preventDefault();
      }
    },
    async traerParrafo() {
      let id = {
        id: this.$route.params.id,
      };
      const result = await apiServices.post("infoemail", id);

      if (result.data.length) {
        const keys = Object.keys(result.data[0]);
        if (keys.includes("colaborador") && keys.includes("lider")) {
          if (result.data[0].lider.cuerpo) {
            this.infoForUser.lider.lider = result.data[0].lider.cuerpo;
          }
          if (result.data[0].colaborador.cuerpo) {
            this.infoForUser.colaboradores.Colaborador =
              result.data[0].colaborador.cuerpo;
          }
          if (result.data[0].lider.title) {
            this.title.lider = result.data[0].lider.title;
          }
          if (result.data[0].colaborador.title) {
            this.title.colaboradores = result.data[0].colaborador.title;
          }
        }
      }
    },
    async traerelaciones() {
      this.relaciones = [];
      let result;
      try {
        result = await apiServices.get(
          `/relacionbyid/${this.$route.params.id}`,
        );
        if (result.data) {
          if (!result.data.proceso.status) {
            await this.$router.replace({ name: "closeSurvey" });
          } else {
            this.relacion = result.data;
            if (result.data.responses) {
              this.responses = result.data.responses;
            }
            const cantidadresponses = Object.keys(this.responses).length;
            this.numberOfOthersResponses = Object.keys(this.responses).filter(
              (v) => {
                if (this.othersQuestions.includes(v)) {
                  return v;
                }
              },
            ).length;

            if (cantidadresponses >= 6) {
              this.pase = 3;
              const cantidad = cantidadresponses - this.numberOfOthersResponses;
              console.log("cantidad", cantidad);
              const calculo = Math.ceil(cantidad / this.perPage);
              console.log("calculo", calculo);

              this.page = calculo
                ? calculo.toFixed(0)
                : (calculo + 1).toFixed(0);
            }
            if (this.relacion.relacion === "Autoevaluacion") {
              this.candidate.isBoss = true;
            } else {
              this.candidate.isBoss = false;
            }
            if (
              this.relacion.status === "terminado" ||
              this.relacion.status === "calculado"
            ) {
              await this.$router.replace({ name: "finencuesta" });
            }
          }
        } else {
          await this.$router.replace({ name: "finencuesta" });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async saveresponses(end) {
      this.relaciones = [];
      const d = {
        id: this.$route.params.id,
        responses: this.responses,
      };
      if (end) {
        d.end = true;
      }
      try {
        await apiServices.post(`/saveresponseslider`, d);
      } catch (err) {
        console.log(err);
      }
    },
    prev() {
      if (this.pase > 1) {
        this.pase -= 1;
      }
    },
    next() {
      this.pase += 1;
      this.saveresponses();
    },
    nextquestions() {
      this.saveresponses();
      this.page++;
      this.scrollTop();
    },
    backquestion() {
      if (this.page > 1) {
        this.page -= 1;
      } else {
        this.prev();
      }
    },
    end() {
      if (this.checkresponses()) {
        this.saveresponses(true);
        this.$store.dispatch("notify", {
          message: `Perfecto. Encuesta finalizada con éxito`,
        });
        this.$router.replace({ name: "finencuesta" });
        setTimeout(function() {
          window.location.replace("https://sietegho.com");
        }, 3000);
      }
    },
    endno() {
      this.saveresponses(false);
      this.$store.dispatch("notify", {
        message: `Perfecto. Proceso finalizado con éxito`,
      });
      this.$router.replace({ name: "finencuesta" });
      setTimeout(function() {
        window.location.replace("https://sietegho.com");
      }, 3000);
    },
    checkresponses() {
      // verifica que todas las preguntas del formulario sean respondidas
      let x = 0;
      let i;
      for (i = 0; i < this.questions.length; i++) {
        // verifica que el objeto responses tenga la propiedad (variable codigo) de cada pregunta
        if (!this.responses.hasOwnProperty(this.questions[i].codigo)) {
          x++;
        }
      }
      if (x > 0) {
        this.$store.dispatch("notify", {
          message: "Aún le falta(n) " + x + " pregunta(s) por responder!",
          type: "is-warning",
          position: "top-center",
        });
        return false;
      } else {
        return true;
      }
    },
    paginate(questions) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return questions.slice(from, to);
    },
    showOtherC(value) {
      if (this.citysNames[this.responses.country][value] === undefined) {
        this.showOtherInput = true;
      } else {
        this.showOtherInput = false;
      }
    },
  },
  computed: {
    displayedQuestions() {
      return this.paginate(this.questions);
    },
  },
  created() {
    this.traerelaciones();
  },
  watch: {
    "responses.age"(val) {
      if (val < 0) {
        this.responses.age = 0;
      }
    },
    otherC(val) {
      this.responses.city = val.toUpperCase();
    },
    relacion(nv) {
      if (nv) {
        if (this.relacion.evaluado) {
          this.numberOfPages = Math.ceil(this.questions.length / this.perPage);
          this.questions.forEach((question, index) => {
            question.numeroPregunta = index + 1;
            return question;
          });
          this.traerParrafo();
        }
      }
    },
    pase(nv) {
      if (Object.keys(this.responses).length < 7) {
        this.numberOfOthersResponses = Object.keys(this.responses).filter(
          (v) => {
            if (this.othersQuestions.includes(v)) {
              return v;
            }
          },
        ).length;
      }
    },
  },
  components: {
    modalConsentimiento,
  },
};
</script>

<style lang="scss">
$color-dark: #363636;
$color-accent: #5e2ca5;

// ══════════════════════════════════════════════════════════════════════
// Logo centrado arriba (reemplaza el hero)
// ══════════════════════════════════════════════════════════════════════
.logo-header {
  text-align: center;
  padding: 1.5rem 0;
}
.logo-img {
  width: 220px;
  max-width: 60%;
}

// ══════════════════════════════════════════════════════════════════════
// Pill flotante
// ══════════════════════════════════════════════════════════════════════
.survey-tag-wrap {
  margin-bottom: -0.75rem;
  position: relative;
  z-index: 1;
}
.survey-tag {
  display: inline-block;
  background: $color-dark;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 0.3rem 0.9rem;
  border-radius: 20px;
}

// ══════════════════════════════════════════════════════════════════════
// Caja principal
// ══════════════════════════════════════════════════════════════════════
.survey-box {
  max-width: 900px; // ← corregido, estaba en 0px
  margin: 0 auto;
  border-radius: 12px;
  padding: 2.25rem 2rem;
}
.survey-title {
  text-align: center;
}
.survey-title--sm {
  text-align: left;
}

// ══════════════════════════════════════════════════════════════════════
// Bloque de texto informativo
// ══════════════════════════════════════════════════════════════════════
.info-block {
  text-align: start;
  background: #f5f5f5;
  border-radius: 10px;
  padding: 1.1rem 1.4rem;
  margin: 1.25rem 0;

  span {
    font-size: 0.9rem;
    line-height: 1.7;
    color: #555;
  }
}
.help-note {
  font-size: 0.78rem;
  color: #888;
}
.help-note__email {
  color: $color-accent;
}

// ══════════════════════════════════════════════════════════════════════
// Datos demográficos
// ══════════════════════════════════════════════════════════════════════
.field-block {
  margin-bottom: 1.5rem;
  display: block;
}
.field-block--half {
  flex: 1;
}
.field-row {
  display: flex;
  gap: 1.5rem;
}
.field-label {
  display: block; // ← corregido, estaba en flex y desalineaba el label
  width: 100%;
  text-align: left;
  font-weight: 700;
  color: $color-dark;
  margin-bottom: 0.7rem;
}
.radio-row {
  display: flex;
  gap: 20px;
}

// Pills de género (b-radio-button)
.pill-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.pill-group .button {
  border-radius: 20px !important;
  padding: 0.6rem 1.25rem !important;
  background-color: #f2f2f2 !important;
  border: 1px solid transparent !important;
  color: $color-dark !important;
  box-shadow: none !important;

  &:hover {
    background-color: #e2e2e2 !important;
  }

  &.is-selected {
    background-color: rgba($color-accent, 0.12) !important;
    border-color: $color-accent !important;
    color: $color-dark !important;

    &:hover {
      background-color: rgba($color-accent, 0.18) !important;
    }
  }
}

// ══════════════════════════════════════════════════════════════════════
// Instrucciones
// ══════════════════════════════════════════════════════════════════════
.instructions-content {
  margin: 0 auto;

  p {
    margin-bottom: 1rem;
    line-height: 1.65;
    color: #444;
  }
}
.scale-example {
  background: #f5f5f5;
  border-radius: 10px;
  padding: 1.1rem 1.25rem;
  margin-bottom: 0.85rem;
}
.scale-example__hint {
  font-size: 0.8rem;
  color: #777;
  margin-bottom: 0.75rem !important;
}

// ══════════════════════════════════════════════════════════════════════
// Escala 1-10 (compartida entre instrucciones y preguntas)
// ══════════════════════════════════════════════════════════════════════
.scale-grid {
  display: grid;
  grid-template-columns: repeat(10, minmax(0, 1fr));
  gap: 5px;

  &--with-nose {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .scale-square,
  .button {
    aspect-ratio: 1;
    height: auto !important;
    min-height: 0 !important;
    border-radius: 8px !important;
    padding: 0 !important;
    font-size: 0.8rem !important;
    font-weight: 500;
    background-color: #f2f2f2 !important;
    border: 1px solid transparent !important;
    color: $color-dark !important;
    box-shadow: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.15s, border-color 0.15s;

    &:hover {
      background-color: #e2e2e2 !important;
    }

    &.is-selected {
      background-color: rgba($color-accent, 0.12) !important;
      border-color: $color-accent !important;
      color: $color-dark !important;

      &:hover {
        background-color: rgba($color-accent, 0.18) !important;
      }
    }
  }
}

.scale-endlabels {
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  font-size: 0.68rem;
  line-height: 1.3;
  color: #999;
  gap: 8px;
}

// ══════════════════════════════════════════════════════════════════════
// Fila de pregunta
// ══════════════════════════════════════════════════════════════════════
.question-row {
  margin-bottom: 1.75rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
}
.question-row__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 0.9rem;
}
.question-row__text {
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
  flex: 1;
  min-width: 200px;
}
.question-row__num {
  font-weight: 700;
  margin-right: 0.2rem;
}

// ══════════════════════════════════════════════════════════════════════
// Footer fijo (progreso + navegación, pase 3)
// ══════════════════════════════════════════════════════════════════════
.survey-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
  border-top: 1px solid #e5e5e5;
  padding: 0.85rem 1.5rem;
  z-index: 30;

  &__inner {
    max-width: 900px;
    margin: 0 auto;
  }
}

.footer-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 0.75rem;
}
.footer-nav__spacer {
  flex: 1;
}
.footer-spacer {
  height: 130px;
}
.progress-wrap {
  margin-top: 0;
}
.progress-info {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: #888;
  margin-bottom: 0.3rem;
}

.button-row {
  display: flex;
  gap: 10px;
  justify-content: center;
}

// ══════════════════════════════════════════════════════════════════════
// Responsive
// ══════════════════════════════════════════════════════════════════════
@media screen and (max-width: 768px) {
  .logo-img {
    width: 160px;
  }
  .section {
    padding: 0.75rem 0.5rem;
  }
  .survey-box {
    padding: 1.25rem 0.6rem !important;
  }
  .field-row {
    flex-direction: column;
    gap: 0;
  }
  .radio-row {
    flex-direction: column;
    gap: 10px;
  }
  .scale-grid {
    gap: 3px;
  }

  .scale-grid--with-nose {
    grid-template-columns: auto repeat(10, minmax(0, 1fr));
  }

  // Los números (aspect-ratio: 1) definen la altura real de la fila del grid;
  // "No sé" no debe llevar una altura fija adivinada, sino estirarse (stretch,
  // el comportamiento por defecto de CSS Grid) para igualar esa altura real,
  // sea cual sea el ancho de columna resultante en cada celular.
  .scale-grid .scale-square--nose {
    aspect-ratio: auto !important;
    padding: 0 0.6rem !important;
    white-space: nowrap;
  }

  // El class del b-radio-button cae en el <div class="control">, no en el
  // <label class="button"> visible — hay que apuntar al label directamente.
  // El <div class="control"> ya se estira solo (es el item del grid), pero el
  // <label> interno necesita height: 100% para heredar esa altura estirada.
  .scale-grid .scale-square-btn--nose .b-radio.radio.button {
    aspect-ratio: auto !important;
    height: 100% !important;
    padding: 0 0.6rem !important;
    white-space: nowrap;
  }

  .scale-square,
  .scale-grid .button {
    font-size: 0.7rem !important;
  }

  .scale-endlabels {
    font-size: 0.6rem;
  }

  // Instrucciones y preguntas: tarjetas compactas para ganar ancho
  .scale-example {
    padding: 0.85rem 0.6rem;
  }

  .question-row {
    background: #fff;
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 0.85rem 0.6rem 1rem;
    margin-bottom: 0.85rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
  .question-row:last-child {
    border-bottom: 1px solid #eee;
  }

  .survey-box--flat {
    border: none !important;
    box-shadow: none !important;
  }

  .survey-footer {
    padding: 0.65rem 1rem;
  }

  .footer-nav {
    gap: 8px;
  }

  .footer-nav__prev,
  .footer-nav__next {
    flex: 1;
  }

  .footer-nav__prev .button,
  .footer-nav__next .button,
  .footer-nav .button {
    width: 100%;
    font-size: 0.8rem !important;
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/EncuestaLider.vue